import * as React from "react";
import * as _ from "lodash";
import i18n from "i18n";
import { Copy } from "common/icons";
import {
  Typography,
  withStyles,
  Tooltip,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { KeyboardArrowDown } from "@material-ui/icons";
import { KeyboardArrowUp } from "@material-ui/icons";
import { Create as CreateIcon } from "@material-ui/icons";
import { Delete } from "@material-ui/icons";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import { Close } from "@material-ui/icons";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { CostPlanService } from "modules/costPlan/CostPlanService";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBSService } from "modules/WBS/WBSService";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { isTimestamp } from "utils/FirebaseUtils";
import { gtag } from "ga-gtag";
import { formatMonetary } from "utils/MathUtils";
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiDialog: {
      paperWidthSm: {
        width: "640px",
        height: "548px",
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: "16px",
        marginBottom: "8px",
        width: "100%",
      },
    },
    MuiInputLabel: {
      root: {
        "&$focused": {
          color: "#ABC200",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#ABC200",
        },
      },
    },
  },
});

const theme2 = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiDialog: {
      paperWidthSm: {
        width: "640px",
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: "16px",
        marginBottom: "8px",
        width: "100%",
      },
    },
    MuiInputLabel: {
      root: {
        "&$focused": {
          color: "#ABC200",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#ABC200",
        },
      },
    },
  },
});

const styles = (theme) => ({
  inputName: {
    fontFamily: "Roboto",
    fontSize: "11px",
    padding: "0px",
    marginTop: "10px",
    marginBottom: "1px",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&::selection": {
      //  background: '#ABC200'
    },
    "&::after": {
      borderBottom: "1px solid !important",
    },
  },
  modelName: {
    color: "#AAAAAB",
    fontSize: "11px",
    marginTop: "10px",
    marginBottom: "1px",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis",
    background: "transparent",
    width: "93%",
    "&:hover": {
      borderBottom: "1px dotted #fff !important",
    },
  },
  checkIcon: {
    fontSize: 20,
    opacity: 0,
    color: "#a8a8a8",
  },
  menu: {
    marginTop: 50,
    padding: "0px",
    border: "none",
  },
  leftIcon: {
    marginRight: 5,
  },
  iconSmall: {
    fontSize: 15,
  },
  button: {
    font: "normal normal bold 9px/20px Raleway",
    color: "rgba(255, 255, 255, 0.6)",
    letterSpacing: "1px",
    fontWeight: "400" as any,
    border: "1px solid #1D1D1D",
    background: "#272727",
    "&:hover": {
      background: "#353539",
    },
    borderRadius: "4px",
    marginTop: "2px",
    marginLeft: "3px",
    padding: "2px 8px",
  },
  iconMenu: {
    fontSize: "15px",
  },
  noOpacity: {
    opacity: 0,
  },
  modelMapItem: {
    display: "flex",
  },
  modelMapItemCheckAvailable: {
    display: "flex",
    "&:hover svg": {
      opacity: 1,
      cursor: "pointer",
    },
  },
  onHoverDiv: {
    background: "#2E2E2E 0% 0% no-repeat padding-box",
    "&:hover": {
      cursor: "pointer",
      background: "#464646",
    },
    "&:hover div": {
      opacity: 1,
    },
  },
  modelMapControls: {
    width: "99%",
    padding: "3px",
    margin: "2px 1px",
    backgroundColor: "#363637",
    cursor: "pointer",
    "&:hover": {
      background: "#464646",
      "& > div > svg": {
        opacity: 1,
      },
    },
  },
  progress: {
    margin: 0,
    color: "#A8A8A8",
    zIndex: 2,
    position: "absolute" as any,
    padding: "3px",
    width: "26px !important",
    height: "26px !important",
  },
  confirmButton: {
    cursor: "pointer",
    padding: "8px 8px",
    color: "#ABC200",
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
  eapInfoWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  modalWbsTitle: {
    background: "#f2f2f2",
    margin: 0,
    padding: "20px",
    fontSize: "20px",
    borderBottom: "1px solid black",
  },
  modalWbsContent: {
    background: "#EEEEEE",
  },
  modalWbsActions: {
    background: "#EEEEEE",
    margin: "0px",
    padding: "1%",
  },
  formContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButton: {
    color: "#646464",
    "&:hover": {
      backgroundColor: "#e3e3e3",
    },
  },
  createNewCostPlanButton: {
    color: "#ABC200",
    "&:hover": {
      backgroundColor: "#e3e3e3",
    },
  },
  eapWrapper: {
    padding: "15px 15px",
    background: "#363637",
    borderBottom: "1px solid #302F31",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&:hover": {
      background: "#464646",
    },
  },
  eapWrapperSelected: {
    padding: "15px 15px",
    background: "#697513",
    borderBottom: "1px solid #302F31",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  eapBoxWrapper: {
    width: "100%",
  },
  eapName: {
    color: "rgba(255, 255, 255, 87)",
    fontSize: "0.8rem",
    fontWeight: 500,
  },
  eapProgress: {
    color: "#FFFFFF",
    fontSize: "0.7rem",
  },
  eapFirstLine: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1%",
  },
  eapPanel: {
    backgroundColor: "#363637",
  },
  eapPanelIcons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "2%",
  },
  eapPanelInside: {
    display: "flex",
  },
});

type IProps = {
  classes: any;
  wbs: any;
  wbsId: string;
  refresh: any;
};

class CostPlanItem extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  state = {
    expand: false,
    anchorEl1: null,
    fillInputNameWbs: false,
    fillDescriptionWbs: false,
    anchorEl: null,
    actualFile: "",
    developmentSelected: "",
    ready: false,
    open: false,
    nameWbs: "",
    descriptionWbs: "",
    openDeleteWbs: false,
    closeDeleteWbs: false,
    openDuplicateWbs: false,
    openWarningWbs: false,
    currentItemId: this.props.wbsId,
    nameWbsAlreadyExists: false,
    currentNameWbs: "",
  };

  componentDidMount() {
    this.setState({ nameWbs: this.props.wbs.nameWbs });
    this.setState({ descriptionWbs: this.props.wbs.description });
    this.setState({ currentNameWbs: this.props.wbs.nameWbs });
  }

  async handleSelectWbs(id) {
    WBSStore.openEAP();
    Render3dStore.resetViewer();
    WBSStore.loading = true;
    if (WBSStore.currentWbsId != id) {
      await WBSStore.changeCurrentCostPlan(id);
    }
    WBSStore.loading = false;
  }

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  handleOpenDeleteWbs = () => {
    this.setState({
      openDeleteWbs: true,
    });
  };

  handleCloseDeleteWbs = () => {
    this.setState({
      openDeleteWbs: false,
    });
  };

  handleOpenWarningWbs = () => {
    this.setState({
      openWarningWbs: true,
    });
  };

  handleCloseWarningWbs = () => {
    this.setState({
      openWarningWbs: false,
    });
  };

  handleClickOpenDuplicateWbs = () => {
    this.setState({ openDuplicateWbs: true });
  };

  handleClickCloseDuplicateWbs = () => {
    this.setState({ nameWbsAlreadyExists: false });
    this.setState({ openDuplicateWbs: false });
  };

  handleClickOpenEditWbs = () => {
    this.setState({ open: true });
  };

  handleClickCloseEditWbs = () => {
    this.setState({ nameWbsAlreadyExists: false });
    this.setState({ open: false });
    this.setState({ nameWbs: this.state.currentNameWbs });
  };

  handleClickClose = () => {
    this.setState({ open: false, anchorEl: null });
    this.setState({ nameWbsAlreadyExists: false });
    this.setState({ nameWbs: this.state.currentNameWbs });
  };

  handleInputNameWbs = (e) => {
    if (e.target.value == "") {
      this.setState({ fillInputNameWbs: false });
    } else {
      this.setState({ fillInputNameWbs: true });
    }
    this.setState({ nameWbs: e.target.value });
  };

  handleInputDescriptionWbs = (e) => {
    if (e.target.value == "") {
      this.setState({ fillDescriptionWbs: false });
    } else {
      this.setState({ fillDescriptionWbs: true });
    }
    this.setState({ descriptionWbs: e.target.value });
  };

  editWbs = async (e) => {
    const nameWbsAlreadyExists = await WBSService.checkEditNameWbsAlreadyExists(
      this.state.nameWbs,
      this.state.currentNameWbs
    );

    if (nameWbsAlreadyExists) {
      this.setState({ nameWbsAlreadyExists: true });
    } else {
      this.setState({ nameWbsAlreadyExists: false });
      await CostPlanService.editWbs(
        this.props.wbsId,
        this.state.nameWbs == undefined ? "" : this.state.nameWbs,
        this.state.descriptionWbs == undefined ? "" : this.state.descriptionWbs
      );
      gtag("event", "editar_plano_custo", {
        editar_plano_custo: 0,
      });

      this.props.refresh();
      this.handleClickClose();
    }
  };

  deleteWbsBtn = async () => {
    await CostPlanService.deleteWbs(this.props.wbsId);
    this.props.refresh();
    this.handleCloseDeleteWbs();
  };

  handleCopyWbs = async () => {
    WBSStore.loading = true;
    const nameWbsAlreadyExists = await WBSService.checkNameWbsAlreadyExists(
      this.state.nameWbs
    );
    if (nameWbsAlreadyExists) {
      this.setState({ nameWbsAlreadyExists: true });
      WBSStore.loading = false;
    } else {
      this.setState({ nameWbsAlreadyExists: false });
      this.setState({ fillInputNameWbs: false });
      this.handleClickCloseDuplicateWbs();

      await CostPlanStore.duplicateCostPlan(
        this.props.wbsId,
        this.state.nameWbs,
        this.state.descriptionWbs
      )
        .then(() => {
          this.props.refresh();
        })
        .finally(() => {
          WBSStore.loading = false;
        });

      gtag("event", "duplicar_plano_custo", {
        duplicar_plano_custo: 0,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { wbs } = this.props;
    const open = Boolean(this.state.anchorEl1);
    const createdDate = isTimestamp(wbs.createdAt)
      ? wbs.createdAt.toDate().toLocaleString("pt-br")
      : String(wbs.createdAt);
    return (
      <>
        <MuiThemeProvider theme={theme}>
          <Dialog
            open={this.state.openDuplicateWbs}
            onClose={this.handleClickCloseDuplicateWbs}
            aria-labelledby="draggable-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
          >
            <DialogTitle
              id="draggable-dialog-title"
              style={{ padding: "20px" }}
              className={classes.modalWbsTitle}
            >
              <p style={{ color: "rgb(0 0 0)", fontSize: "18px", margin: 0 }}>
                {i18n.costplan.duplicateCostPlan} {wbs.name}
              </p>
              <IconButton
                onClick={this.handleClickCloseDuplicateWbs}
                className={classes.closeIcon}
                style={{ position: "absolute" }}
              >
                <Close fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent className={classes.modalWbsContent}>
              <DialogContentText style={{ padding: 0 }}>
                <form
                  className={classes.formContainer}
                  style={{ flexDirection: "column" }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    id="standard-name"
                    label={i18n.costplan.costPlanName}
                    className={classes.textField}
                    value={this.state.nameWbs}
                    onChange={this.handleInputNameWbs}
                    error={this.state.nameWbsAlreadyExists}
                    helperText={
                      this.state.nameWbsAlreadyExists
                        ? i18n.costplan.nameWbsAlreadyExists
                        : ""
                    }
                    margin="normal"
                  />
                  <TextField
                    id="standard-description"
                    label={i18n.costplan.costPlanDescription}
                    className={classes.textField}
                    onChange={this.handleInputDescriptionWbs}
                    margin="normal"
                  />
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.modalWbsActions}>
              <Button
                onClick={this.handleClickCloseDuplicateWbs}
                className={classes.cancelButton}
              >
                Cancelar
              </Button>
              {this.state.fillInputNameWbs == true ? (
                <Button
                  onClick={this.handleCopyWbs}
                  className={classes.createNewCostPlanButton}
                >
                  {i18n.costplan.duplicateCostPlan}
                </Button>
              ) : (
                <Button
                  onClick={this.handleCopyWbs}
                  disabled={true}
                  className={classes.createNewCostPlanButton}
                >
                  {i18n.costplan.duplicateCostPlan}
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </MuiThemeProvider>

        <MuiThemeProvider theme={theme}>
          <Dialog
            open={this.state.open}
            onClose={this.handleClickCloseEditWbs}
            aria-labelledby="draggable-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
          >
            <DialogTitle
              id="draggable-dialog-title"
              style={{ padding: "20px" }}
              className={classes.modalWbsTitle}
            >
              <p style={{ color: "rgb(0 0 0)", fontSize: "18px", margin: 0 }}>
                Editar plano de custo
              </p>
              <IconButton
                onClick={this.handleClickClose}
                className={classes.closeIcon}
                style={{ position: "absolute" }}
              >
                <Close fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent className={classes.modalWbsContent}>
              <DialogContentText style={{ padding: 0 }}>
                <form
                  className={classes.formContainer}
                  style={{ flexDirection: "column" }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    id="standard-name"
                    label={i18n.costplan.costPlanName}
                    className={classes.textField}
                    value={this.state.nameWbs}
                    onChange={this.handleInputNameWbs}
                    error={this.state.nameWbsAlreadyExists}
                    helperText={
                      this.state.nameWbsAlreadyExists
                        ? i18n.costplan.nameWbsAlreadyExists
                        : ""
                    }
                    margin="normal"
                  />
                  <TextField
                    id="standard-name"
                    label={i18n.costplan.costPlanDescription}
                    className={classes.textField}
                    value={this.state.descriptionWbs}
                    onChange={this.handleInputDescriptionWbs}
                    margin="normal"
                  />
                </form>
              </DialogContentText>
            </DialogContent>

            <DialogActions className={classes.modalWbsActions}>
              <Button
                onClick={this.handleClickClose}
                className={classes.cancelButton}
              >
                {i18n.costplan.cancel}
              </Button>
              <Button
                onClick={this.editWbs}
                className={classes.createNewCostPlanButton}
              >
                {i18n.costplan.save}
              </Button>
            </DialogActions>
          </Dialog>
        </MuiThemeProvider>

        <MuiThemeProvider theme={theme2}>
          <Dialog
            open={this.state.openDeleteWbs}
            onClose={this.handleCloseDeleteWbs}
            aria-labelledby="draggable-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
          >
            <DialogTitle
              id="draggable-dialog-title"
              style={{ padding: "20px" }}
              className={classes.modalWbsTitle}
            >
              <p style={{ color: "rgb(0 0 0)", fontSize: "18px", margin: 0 }}>
                {i18n.costplan.delete} {wbs.nameWbs}?
              </p>
              <IconButton
                onClick={this.handleCloseDeleteWbs}
                className={classes.closeIcon}
                style={{ position: "absolute" }}
              >
                <Close fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent className={classes.modalWbsContent}>
              <DialogContentText style={{ padding: 0 }}>
                <p>{i18n.costplan.alertDeleteCostPlan}</p>
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.modalWbsActions}>
              <Button
                onClick={this.handleCloseDeleteWbs}
                className={classes.cancelButton}
              >
                {i18n.costplan.cancel}
              </Button>

              <Button
                onClick={this.deleteWbsBtn}
                style={{ color: "#D73912" }}
                className={classes.createNewCostPlanButton}
              >
                {i18n.costplan.delete}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.openWarningWbs}
            onClose={this.handleOpenWarningWbs}
            aria-labelledby="draggable-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
          >
            <DialogTitle
              id="draggable-dialog-title"
              style={{ padding: "20px" }}
              className={classes.modalWbsTitle}
            >
              <p style={{ color: "rgb(0 0 0)", fontSize: "18px", margin: 0 }}>
                {i18n.costplan.unavailableAction}
              </p>
              <IconButton
                onClick={this.handleCloseWarningWbs}
                className={classes.closeIcon}
                style={{ position: "absolute" }}
              >
                <Close fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent className={classes.modalWbsContent}>
              <DialogContentText style={{ padding: 0 }}>
                <p>{i18n.costplan.warningOneCostPlan}</p>
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.modalWbsActions}>
              <Button
                onClick={this.handleCloseWarningWbs}
                className={classes.createNewCostPlanButton}
              >
                {i18n.costplan.acceptWarning}
              </Button>
            </DialogActions>
          </Dialog>
        </MuiThemeProvider>
        {this.props.wbs.isSelected == true ? (
          <div
            className={classes.eapWrapperSelected}
            onClick={() => {
              this.handleSelectWbs(this.props.wbsId);
            }}
          >
            <div className={classes.eapBoxWrapper}>
              <div className={classes.eapFirstLine}>
                <Typography className={classes.eapName}>
                  {wbs.nameWbs}
                </Typography>
                {this.state.expand == false ? (
                  <a
                    onClick={(event) => {
                      this.killEvent(event);
                    }}
                  >
                    <KeyboardArrowDown
                      aria-label="Mais"
                      aria-owns={open ? "long-menu" : undefined}
                      aria-haspopup="true"
                      onClick={() => {
                        this.setState({ expand: true });
                      }}
                      style={{
                        padding: "0px",
                        background: "transparent",
                        color: "#a8a8a8",
                        height: "auto",
                      }}
                    />{" "}
                  </a>
                ) : (
                  <a
                    onClick={(event) => {
                      this.killEvent(event);
                    }}
                  >
                    <KeyboardArrowUp
                      aria-label="Mais"
                      aria-owns={open ? "long-menu" : undefined}
                      aria-haspopup="true"
                      onClick={() => {
                        this.setState({ expand: false });
                      }}
                      style={{
                        padding: "0px",
                        background: "transparent",
                        color: "#a8a8a8",
                        height: "auto",
                      }}
                    />
                  </a>
                )}
              </div>
              <Tooltip title={wbs.description} className={classes.tooltip}>
                <Typography
                  variant="body1"
                  gutterBottom
                  className={classes.eapProgress}
                  style={{
                    maxWidth: "100%",
                    whiteSpace: "nowrap",
                    paddingBottom: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {wbs.description}
                </Typography>
              </Tooltip>
              <div className={classes.eapInfoWrapper}>
                <Typography className={classes.eapProgress}>
                  {formatMonetary(WBSStore.currentWbsTotalCost)}
                </Typography>
                <Typography className={classes.eapProgress}>
                  {createdDate}
                </Typography>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={classes.eapWrapper}
            onClick={() => {
              this.handleSelectWbs(this.props.wbsId);
            }}
          >
            <div className={classes.eapBoxWrapper}>
              <div className={classes.eapFirstLine}>
                <Typography className={classes.eapName}>
                  {wbs.nameWbs}
                </Typography>
                {this.state.expand == false ? (
                  <a
                    onClick={(event) => {
                      this.killEvent(event);
                    }}
                  >
                    <KeyboardArrowDown
                      aria-label="Mais"
                      aria-owns={open ? "long-menu" : undefined}
                      aria-haspopup="true"
                      onClick={() => {
                        this.setState({ expand: true });
                      }}
                      style={{
                        padding: "0px",
                        background: "transparent",
                        color: "#a8a8a8",
                        height: "auto",
                      }}
                    />{" "}
                  </a>
                ) : (
                  <a
                    onClick={(event) => {
                      this.killEvent(event);
                    }}
                  >
                    <KeyboardArrowUp
                      aria-label="Mais"
                      aria-owns={open ? "long-menu" : undefined}
                      aria-haspopup="true"
                      onClick={() => {
                        this.setState({ expand: false });
                      }}
                      style={{
                        padding: "0px",
                        background: "transparent",
                        color: "#a8a8a8",
                        height: "auto",
                      }}
                    />
                  </a>
                )}
              </div>
              <Tooltip title={wbs.description} className={classes.tooltip}>
                <Typography
                  variant="body1"
                  gutterBottom
                  className={classes.eapProgress}
                  style={{
                    maxWidth: "190px",
                    whiteSpace: "nowrap",
                    paddingBottom: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {wbs.description}
                </Typography>
              </Tooltip>
              <div className={classes.eapInfoWrapper}>
                <Typography className={classes.eapProgress}>
                  {formatMonetary(wbs.totalCost)}
                </Typography>
                <Typography className={classes.eapProgress}>
                  {createdDate}
                </Typography>
              </div>
            </div>
          </div>
        )}

        {this.state.expand == true ? (
          <div className={classes.eapPanel}>
            <hr style={{ border: "1px solid #4E4E4E", margin: 0 }}></hr>

            <div className={classes.eapPanelIcons}>
              <div className={classes.eapPanelInside}>
                {WBSStore.listWbs.length > 1 ? (
                  <MenuItem
                    style={{ padding: "0px 3px", margin: "0px 6px" }}
                    onClick={this.handleOpenDeleteWbs}
                  >
                    <Tooltip title={i18n.delete}>
                      <Delete className={classes.iconMenu} />
                    </Tooltip>
                  </MenuItem>
                ) : (
                  <MenuItem
                    style={{ padding: "0px 3px", margin: "0px 6px" }}
                    onClick={this.handleOpenWarningWbs}
                  >
                    <Tooltip title={i18n.delete}>
                      <Delete className={classes.iconMenu} />
                    </Tooltip>
                  </MenuItem>
                )}

                <MenuItem
                  style={{ padding: "0px 3px", margin: "0px 6px" }}
                  onClick={this.handleClickOpenDuplicateWbs}
                >
                  <Tooltip title={"Duplicar esse plano de custo"}>
                    <Copy className={classes.iconMenu} />
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  onClick={this.handleClickOpenEditWbs}
                  style={{ padding: "0px 3px", margin: "0px 6px" }}
                >
                  <Tooltip title={i18n.editto}>
                    <CreateIcon className={classes.iconMenu} />
                  </Tooltip>
                </MenuItem>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <Divider light />
      </>
    );
  }
}

export default withStyles(styles)(CostPlanItem);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/layouts/CostPlanItem.tsx